export default "__VITE_ASSET__Cop0gUkb__"